<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Routing Setup</h4>
        <p>Static Route Table:</p>
        <el-table :data="tableData" stripe style="width: 100%" border class="fhv-table">
            <el-table-column prop="address" label="Destination IP Address" width="180"></el-table-column>
            <el-table-column prop="netmask" label="Netmask" width="180"></el-table-column>
            <el-table-column prop="gateway" label="Gateway" width="180"></el-table-column>
            <el-table-column prop="metric" label="Metric"></el-table-column>
            <el-table-column prop="interface" label="Interface"></el-table-column>
            <el-table-column prop="status" label="Status" v-if="enable"></el-table-column>
            <el-table-column prop="" label="Select">
                  <template slot-scope="scope">
                    <el-button
                        @click.native.prevent="deleteRow(scope.$index, tableData)"
                        type="text"
                        :disabled="$G_DEVICE_CFG.isReadOnly"
                        size="small">
                        Delete
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
         <div class="btn-contain">
            <el-button type="primary" @click="dialogFormVisible = true" :disabled="$G_DEVICE_CFG.isReadOnly">Add</el-button>
        </div>


        <el-dialog title="" :visible.sync="dialogFormVisible" :lock-scroll="false" width="40%">
            <div class="change">
                <i for="">Enable Static Route:</i>
                <!-- <el-checkbox v-model="form.flag" class="bigCheck" :disabled="false"></el-checkbox> -->
                <el-switch v-model="form.flag" ></el-switch>
            </div>
            <el-form :model="form" size="mini" :disabled="$G_DEVICE_CFG.isReadOnly || !form.flag" :inline-message="true"  :rules="rules"
            ref="forms">
               <el-form-item label="IP Address:" :label-width="formLabelWidth" prop="address">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
                <el-form-item label="Subnet Mask:" :label-width="formLabelWidth" prop="mask">
                    <el-input v-model="form.mask" auto-complete="off" ></el-input>
                </el-form-item>
                <el-form-item label="Gateway:" :label-width="formLabelWidth" prop="gateway">
                    <el-input v-model="form.gateway" auto-complete="off" ></el-input>
                </el-form-item>
                <el-form-item label="Metric:" :label-width="formLabelWidth" prop="metric">
                    <el-input v-model.number="form.metric" auto-complete="off" maxlength="2"></el-input>
                </el-form-item>

                <el-form-item label="Interface:" :label-width="formLabelWidth" >
                    <el-select v-model="form.interface" placeholder="Please select" style="width:100%;">
                         <el-option v-for="(item,index) in selList" :key="index" :value="item.value" :label="item.label"></el-option>
                     </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" >
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="add">Confirm</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
  data() {
    return {
      enable: false,
      dialogFormVisible: false,
      loading: false,
      form: {
        flag: true,
        address: "",
        mask: "",
        gateway: "",
        metric: "",
        interface: "0"
      },
      formLabelWidth: "180px",
      selList: [],
      data: [],
      tableData: [
        /* {
                    address
                    netmask
                    gateway
                    metric
                    interface
                    status
                } */
      ],
      rules: {
        address: [
          {
            validator: (rule, value, callback) => {
              if (!validator.isIP(value) || value.split(".")[0] == "127") {
                callback(new Error("Invalid IP address value!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        mask: [
          {
            validator: (rule, value, callback) => {
              let exp = /^(254|252|248|240|224|192|128|0)\.0\.0\.0|255\.(254|252|248|240|224|192|128|0)\.0\.0|255\.255\.(254|252|248|240|224|192|128|0)\.0|255\.255\.255\.(254|252|248|240|224|192|128|0)$/;
              if (!exp.test(value)) {
                callback(
                  new Error(
                    "Invalid subnet mask in 1st digit. It should be the number of 128, 192, 224, 240, 248, 252 or 254!"
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        gateway: [
          {
            validator: (rule, value, callback) => {
              if (!validator.isIP(value) || value.split(".")[0] == "127") {
                callback(
                  new Error(
                    "Invalid Gateway address! range in 1st digit. It should not be 127!"
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        metric: [
          {
            type: "number",
            min: 1,
            max: 15,
            message: "Invalid metric value! The range of Metric is 1 ~ 15!",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    deleteRow(index, rows) {
      if (index == "all") {
        this.del(index);
      } else {
        this.del(index + 1);
      }
    },
    del(index) {
      if (index == "all") {
        var postData = {
          Delete_All: "Delete All",
          submit_url: "/route.htm"
        };
      } else {
        var postData = {
          deleteSelRoute: "Delete Selected",
          submit_url: "/route.htm"
        };
        var name = `select${index}`;
        postData[name] = "ON";
      }

      this.loading = true;
      axios.post("/boafrm/setformRoute", postData).then(res => {
        this.loading = false;
         this.$message.success(res.data.msg);
        this.getData();
      });
    },
    getData() {
      this.loading = true;
      axios.post("/boafrm/getRoutingStatus").then(res => {
        this.loading = false;
        let data = res.data;
        this.data = data;
        this.tableData = [];
        for (var i = 0; i < data.tableData.length - 1; i++) {
          if (data.tableData[i].enable != undefined) {
            this.enable = true;
            this.tableData.push({
              address: data.tableData[i].ip,
              netmask: data.tableData[i].netmask,
              gateway: data.tableData[i].gateway,
              metric: data.tableData[i].metric,
              interface: data.tableData[i].interface,
              status: data.tableData[i].enable == 0 ? "Disabled" : "Enabled"
            });
          } else {
            this.enable = false;
            this.tableData.push({
              address: data.tableData[i].ip,
              netmask: data.tableData[i].netmask,
              gateway: data.tableData[i].gateway,
              metric: data.tableData[i].metric,
              interface: data.tableData[i].interface
            });
          }
        }
      });
      this.selList = [];
      axios.post("/boafrm/getRouteSelStatus").then(res => {
  
        for (var i = 0; i < res.data.list.length - 1; i++) {
          this.selList.push({
            value: res.data.list[i].value,
            label: res.data.list[i].label
          });
        }
      });
    },
    add() {
      if (
       this.form.address == "" &&
       this.form.mask == "" &&
       this.form.gateway == ""
      ) {
        this.ajax();
        return
      }
      this.$refs["forms"].validate(valid => {
        if (valid) {
          this.ajax();
        }
      });
    },
    ajax() {
      if (this.form.address) {
        let ip = this.form.address.split(".");
        ip[3] = 0;
        this.form.address = ip.join(".");
      }
      let postData = {
        enabled: this.form.flag == true ? "ON" : "",
        ipAddr: this.form.address,
        subnet: this.form.mask,
        gateway: this.form.gateway,
        metric: this.form.metric,
        iface: this.form.interface,
        addRoute: "Save",
        addRouteFlag: "1",
        "submit-url": "/route.htm"
      };
      this.loading = true;
      this.dialogFormVisible = false;
      axios.post("/boafrm/setformRoute", postData).then(res => {
        this.loading = false;
        this.dialogFormVisible = false;
        this.$message.success(res.data.msg);
         this.$refs["forms"].resetFields();
        this.getData();
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.fhv-centent {

  h4 {
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 15px;
  }
  .change {
    margin-bottom: 45px;
  }
  .btn-contain {
    width: 100%;
    margin-top: 25px;
    text-align: center;
    padding: 0;
  }
  .change {
    margin-bottom: 22px;
    i {
      align-self: flex-start;
      width: 180px;
      text-align: right;
      font-size: 14px;
      color: #606266;
      padding-right: 12px;
      font-weight: bold;
      opacity: 1;
    }
  }
}
</style>



